import { useLocationsStatsRetrieve } from "@sidegigllc/api/client";
import { useUserRoleForLocation } from "domains/auth";
import { useAtomValue } from "jotai";
import { useFeatureFlag } from "providers/LaunchDarkly";
import { onboardingOffered, onboardingOn, skippedTakeoverAtom } from "../lib/takeover";
import type { TakeoverFlags } from "../lib/takeover-flags";

/** Whether onboarding may open for this location, and whether it is still before the first post. Onboarding only: the chat's canvas is `useCanvasPosting`. */
export const useOnboarding = (locationId: number | undefined) => {
  const flags: TakeoverFlags = {
    chatEnabled: useFeatureFlag("agent-web-header-button-admin"),
    onboardingEnabled: useFeatureFlag("agent-web-onboarding"),
  };
  const skipped = useAtomValue(skippedTakeoverAtom);
  const isOnsiteManager = useUserRoleForLocation(locationId ?? -1) === "ONSITE_MANAGER";

  /** The same gate for other flag values: the first-post redirect decides on the flags LaunchDarkly resolves. */
  const gateWith = (given: TakeoverFlags) => {
    const enabled = onboardingOn(given);
    return { enabled, offered: onboardingOffered({ enabled, locationId, skipped, isOnsiteManager }) };
  };

  const { enabled, offered } = gateWith(flags);
  const stats = useLocationsStatsRetrieve(locationId ?? -1, {
    query: { enabled: offered, staleTime: Number.POSITIVE_INFINITY },
  });

  return { enabled, offered, beforeFirstPost: offered && stats.data?.has_posted_first_gig === false, gateWith };
};
